import { render, staticRenderFns } from "./LocalImageSelector.vue?vue&type=template&id=22ae2cfc&scoped=true"
import script from "./LocalImageSelector.vue?vue&type=script&lang=ts"
export * from "./LocalImageSelector.vue?vue&type=script&lang=ts"
import style0 from "./LocalImageSelector.vue?vue&type=style&index=0&id=22ae2cfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ae2cfc",
  null
  
)

export default component.exports